

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Address, Controller } from '@/store/models';
import Addresses from '@/store/modules/addresses';
import Controllers from '@/store/modules/controllers';
import { secsToStr } from '@/store/common';

@Component({
  methods: {
    secsToStr,
  },
})
export default class CController extends Vue {
  @Prop() public controller!: Controller;
  @Prop() public editCallback!: (ctrl: Controller) => void;

  get addresses(): Address[] {
    return Addresses.addresses;
  }

  private controllerAddress(): string {
    let addrStr: string = 'Адрес';
    if (Addresses.addresses) {
      Addresses.addresses.forEach((addr) => {
        if (addr.id === this.controller.addressId) {
          addrStr = `${addr.city}, ${addr.street}, ${addr.house}/${addr.building ? addr.building : ''}, ${addr.flat}`;
        }
      });
    }
    return addrStr;
  }
}
